import {Serializer} from '../interfaces/serializer';
import {DataSetDimensionsGroup} from '../interfaces/dimensions';
import {BehaviorSubject} from 'rxjs';
import {DimensionComponentObject, DimensionComponentObjects} from './dimension-component-object';
import {DataSource} from '../interfaces/data-source';

export type DatasetDimensionsGroupComponentObjects = Array<DatasetDimensionsGroupComponentObject>;

export class DatasetDimensionsGroupComponentObject {
  public payload: Serializer<DataSetDimensionsGroup | DataSource>;

  public readonly name$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public readonly slug$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  public readonly length$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  public readonly items$: BehaviorSubject<DimensionComponentObjects> = new BehaviorSubject<DimensionComponentObjects>([]);

  public readonly primaries$: BehaviorSubject<Array<DimensionComponentObject>> = new BehaviorSubject<Array<DimensionComponentObject>>([]);
  public readonly secondaries$: BehaviorSubject<Array<DimensionComponentObject>> = new BehaviorSubject<Array<DimensionComponentObject>>([]);
  public readonly hiddenFields$: BehaviorSubject<Array<DimensionComponentObject>> = new BehaviorSubject<Array<DimensionComponentObject>>([]);

  public readonly loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(payload: Serializer<DataSetDimensionsGroup | DataSource>) {
    this.update(payload);
  }

  public update(payload: Serializer<DataSetDimensionsGroup | DataSource>): void {
    this.payload = payload;

    this.name$.next(payload.attributes.name);
    this.slug$.next(payload.attributes.slug);
  }

  public init(generalDimensions: DimensionComponentObjects, dataSetDimensions: DimensionComponentObjects, dataSetConditionalDimensions: DimensionComponentObjects): void {
    let dimensions: DimensionComponentObjects = [];

    switch (this.payload.type) {
      case 'data_set_dimensions_group':
        dimensions = [
          ...generalDimensions.filter((dimension: DimensionComponentObject) => dimension.payload.relationships.data_set_dimensions_group.data?.id === this.payload.id),
          ...dataSetDimensions.filter((dimension: DimensionComponentObject) => dimension.payload.relationships.data_set_dimensions_group.data?.id === this.payload.id),
          ...dataSetConditionalDimensions.filter((dimension: DimensionComponentObject) => dimension.payload.relationships.data_set_dimensions_group.data?.id === this.payload.id)
        ];
        break;
      case 'data_set_usage':
        dimensions = [
          ...generalDimensions.filter((dimension: DimensionComponentObject) => dimension.payload.relationships.data_source.data?.id === this.payload.relationships.data_source.data.id),
          ...dataSetDimensions.filter((dimension: DimensionComponentObject) => dimension.payload.relationships.data_source.data?.id === this.payload.relationships.data_source.data.id),
          ...dataSetConditionalDimensions.filter((dimension: DimensionComponentObject) => dimension.payload.relationships.data_source.data?.id === this.payload.relationships.data_source.data.id)
        ];
        break;
    }

    this.items$.next(dimensions);
    this.length$.next(dimensions.length);

    this.primaries$.next(dimensions.filter((dimension: DimensionComponentObject): boolean => dimension.payload.attributes.visibility === 'primary' || !('visibility' in dimension.payload.attributes)));
    this.secondaries$.next(dimensions.filter((dimension: DimensionComponentObject): boolean => dimension.payload.attributes.visibility === 'secondary'));
    this.hiddenFields$.next(dimensions.filter((dimension: DimensionComponentObject): boolean => dimension.payload.attributes.visibility === 'hidden'));

    this.loading$.next(false);
  }

  public filterDimensions(condition: (dimension: DimensionComponentObject) => boolean): DatasetDimensionsGroupComponentObject {
    const group: DatasetDimensionsGroupComponentObject = new DatasetDimensionsGroupComponentObject(this.payload);

    group.init(this.items$.value.filter(condition), [], []);

    return group;
  }

}
